import { crv, css, cva } from '@/styled-system/css';
import type { SystemStyleObject } from '@/styled-system/types';

const defaultSizeStyles = css.raw({
  blockSize: 'auto',
  maxBlockSize: 'none',
  inlineSize: 'auto',
  maxInlineSize: 'none',
  paddingBlock: 'layout.looser',
  paddingInline: 'layout.tight',
});

const sizeVariants = crv('size', {
  xs: defaultSizeStyles,
  sm: defaultSizeStyles,
  md: defaultSizeStyles,
  lg: defaultSizeStyles,
  xl: defaultSizeStyles,
  fullScreen: {
    blockSize: '100%',
    maxBlockSize: '100%',
    inlineSize: '100%',
    maxInlineSize: '100%',
    paddingBlock: 'Modal.Backdrop.padding.fullScreen.vert',
    paddingInline: 'Modal.Backdrop.padding.fullScreen.horz',
  },
});

export const modalBackdropRecipe: {
  (props?: any): string;
  raw: (props?: any) => SystemStyleObject;
} = cva({
  base: {
    display: 'grid',
    placeItems: 'center',
    zIndex: 'modal',
    animation: 'fade 0.2s ease-out',

    _before: {
      content: '""',
      position: 'fixed',
      inset: 0,
      backgroundColor: 'bg.screen.scrim',
      opacity: 'dialogScrim',
      zIndex: 1,
    },
  },
  variants: {
    scrollDocument: {
      true: {
        // Sets top position to be top, instead of center of viewport
        alignItems: 'start',
        // Switches from `grid` to `flex` to remove padding collapse
        display: 'flex',
        // Centers the content in the viewport
        justifyContent: 'center',
      },
      false: {},
    },
    ...sizeVariants,
  },
});
